import { useMemo } from 'react';
import { Extensions } from '@tiptap/core';
import Document from '@tiptap/extension-document';

import useClientCommonTiptapEditorExtensions from '../../../components/tiptapEditor/useClientCommonTiptapEditorExtensions';

type Props = {
    isEditable: boolean;
};

const useTableCellTiptapExtensions = ({ isEditable }: Props): Extensions => {
    const commonExtensions = useClientCommonTiptapEditorExtensions({ isEditable });

    return useMemo(() => [Document, ...commonExtensions] as Extensions, [commonExtensions]);
};

export default useTableCellTiptapExtensions;
